import { atom } from 'recoil';
import dayjs from 'dayjs';

export const selectedClinicAvailableDaysState = atom({
  key: 'selectedClinicAvailableDaysState',
  default: [],
});

export const selectedClinicAvailabilitiesFilteredState = atom({
  key: 'selectedClinicAvailabilitiesFilteredState',
  default: [],
});

export const selectedClinicIdState = atom({
  key: 'selectedClinicIdState',
  default: null,
});

export const preSelectedClinicIdState = atom({
  key: 'preSelectedClinicIdState',
  default: null,
});

export const selectedDayjsState = atom({
  key: 'selectedDayjsState',
  default: dayjs(),
});

export const selectedMedicalFileIdState = atom({
  key: 'selectedMedicalFileIdState',
  default: null,
});

export const selectedSchedulerTherapistIdState = atom({
  key: 'selectedSchedulerTherapistIdState',
  default: '',
});

export const selectedServiceIdState = atom({
  key: 'selectedServiceIdState',
  default: null,
});

export const selectedSubserviceIdState = atom({
  key: 'selectedSubserviceIdState',
  default: null,
});

export const selectedTherapistState = atom({
  key: 'selectedTherapistState',
  default: null,
});

export const selectedUITherapistState = atom({
  key: 'selectedUITherapistState',
  default: null,
});

export const selectedTimeSlotState = atom({
  key: 'selectedTimeSlotState',
  default: null,
});

export const selectedTreatmentIdState = atom({
  key: 'selectedTreatmentIdState',
  default: 1,
});

const selectedClinicAvailabilitiesState = atom({
  key: 'selectedClinicAvailabilitiesState',
  default: [],
});

export default selectedClinicAvailabilitiesState;
